import { Box, Stack, useTheme } from "@mui/material";
import * as React from "react";

import type { DateRange, QuickFilterOption } from "@/shared/components";
import { ActionRecord } from "@/shared/domain/actions";

import InvokeActionButton from "../action/InvokeActionButton";
import InvocationSourceFilter from "../invocation/InvocationSourceFilter";
import InvocationStatusFilter from "../invocation/InvocationStatusFilter";
import { type UserFacingStatus } from "../invocation/invocationStatusUtils";

import { CancelAll } from "./CancelAll";
import { DateRangeSelector } from "./DateRangeSelector";
import styles from "./InvocationControlBar.module.css";

interface InvocationControlBarProps {
  action?: ActionRecord;
  datasetId?: string;
  dateRange: DateRange;
  defaultQuickFilter?: QuickFilterOption;
  onDateRangeChange: (range: DateRange) => void;
  onSourceChange: (sources: string[]) => void;
  onStatusChange: (statuses: UserFacingStatus[]) => void;
  quickFilters?: QuickFilterOption[];
  selectedSources: string[];
  selectedStatuses: UserFacingStatus[];
}

export const InvocationControlBar: React.FC<InvocationControlBarProps> = ({
  dateRange,
  onDateRangeChange,
  quickFilters,
  defaultQuickFilter,
  selectedStatuses,
  onStatusChange,
  selectedSources,
  onSourceChange,
  action,
  datasetId,
}) => {
  const theme = useTheme();

  return (
    <div
      className={styles.controlBar}
      style={{
        marginBottom: theme.spacing(2),
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        flexWrap="wrap"
        className={styles.mainRow}
      >
        <InvokeActionButton action={action} datasetId={datasetId} />

        <CancelAll datasetId={datasetId} />

        <Box
          sx={{
            display: {
              xs: "none",
              md: "flex",
            },
          }}
        >
          <DateRangeSelector
            dateRange={dateRange}
            onDateRangeChange={onDateRangeChange}
            quickFilters={quickFilters}
            defaultQuickFilter={defaultQuickFilter}
          />
        </Box>

        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            display: {
              xs: "none",
              sm: "flex",
            },
          }}
        >
          <InvocationStatusFilter
            selectedStatuses={selectedStatuses}
            onStatusChange={onStatusChange}
          />
          <InvocationSourceFilter
            selectedSources={selectedSources}
            onSourceChange={onSourceChange}
          />
        </Stack>
      </Stack>
    </div>
  );
};
